import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import useNestedArrayChangeCallbacks from '@/shared/hooks/useNestedArrayChangeCallbacks.ts'
import { memo, useEffect } from 'react'
import textChartUtils from '@/pages/Dashboards/Charts/TextChart/textChart.utils'
import { ITextWidgetSettings } from '@/pages/Dashboards/Charts/TextChart/textChart.types'
import TextChartSettingContent from '@/pages/Dashboards/Charts/TextChart/TextChartSetiingSidePage/TextChartSettingContent'

interface IProps {
  onChange: (val: ITextWidgetSettings) => void
}

const CreateTextChartSettingsContent = (props: IProps) => {
  const [settings, setSettings, handleChange] = useStateWithChange(textChartUtils.generateEmptyChartTextSettings())

  useEffect(() => {
    props.onChange(settings)
  }, [settings, props.onChange])

  const {
    handleElementDelete: handleParameterTextDelete,
    handleElementUpdate: handleParameterTextUpdate,
    handleCreateNewElement: handleParameterTextCreate,
  } = useNestedArrayChangeCallbacks({
    nestedArrayKey: 'parametersText',
    sourceObjectSetter: setSettings,
    newEntityGenerator: textChartUtils.generateEmptyParameterText,
  })

  return (
    <div className="flex-lines gap16">
      <h4 className="text-heading-4">Создание виджета: Текст и переменные</h4>
      <TextChartSettingContent
        settings={settings}
        onChange={handleChange}
        handleParameterTextCreate={handleParameterTextCreate}
        handleParameterTextDelete={handleParameterTextDelete}
        handleParameterTextUpdate={handleParameterTextUpdate}
      />
    </div>
  )
}

export default memo(CreateTextChartSettingsContent)
